import { useCallback } from 'react';
import { usePatientContext as useMainPatientContext } from '../components/patinetProvider';
import { usePatientContext as useSubPatientContext } from '../components/SubPatinetProvider';
import { useCycle } from '../components/cycleContext/CycleContext';
import { useClinic } from '../components/ClinicProvider';

/**
 * Shared hook for clearing all app providers on logout.
 * Used by both manual logout (UserSettingsComponent) and auto-logout (useSessionTimeout).
 * Centralizes the logout cleanup logic to prevent drift between implementations.
 */
export const useClearAppProviders = () => {
  const { removePatient, setMainPatientDetails } = useMainPatientContext();
  const { removeSubPatient, setSubPatientData } = useSubPatientContext();
  const { setCycleId, setSelectedCycle, setCycleIdForFertility, setSurgeryCycleId } = useCycle();
  const { setClinicId } = useClinic();

  const clearAppProviders = useCallback(() => {
    removePatient();
    setMainPatientDetails(null);
    removeSubPatient();
    if (setSubPatientData) {
      setSubPatientData([]);
    }
    setCycleId(null);
    setSelectedCycle(null);
    setCycleIdForFertility(null);
    setSurgeryCycleId(null);
    setClinicId('');
  }, [
    removePatient,
    setMainPatientDetails,
    removeSubPatient,
    setSubPatientData,
    setCycleId,
    setSelectedCycle,
    setCycleIdForFertility,
    setSurgeryCycleId,
    setClinicId,
  ]);

  return clearAppProviders;
};

export default useClearAppProviders;
